import React from 'react';

function ProgressBar({ current, total }) {
  if (total === 0) {
    return null; 
  }

  const percentage = (current / total) * 100;

  return (
    <div className="c3-progress-bar-container">
      <div id="slide_text" className="c3-progress-bar-title">Progress</div>
      <div className="c3-progress-bar-bg">
        <div
          className="c3-progress-bar-fill"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      <div className="c3-progress-bar-percent">
        {Math.round(percentage)}%
      </div>
    </div>
  );
}

export default ProgressBar;